import { Card, CardContent, Box, TextField, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { REPORT_APPS } from "@/models/report";
import { FormLabel } from "./FormLabel";

interface FormFieldsCardProps {
  app: string;
  email: string;
  description: string;
  onAppChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

export function FormFieldsCard({
  app,
  email,
  description,
  onAppChange,
  onEmailChange,
  onDescriptionChange,
}: FormFieldsCardProps) {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          minHeight: 0,
          "&:last-child": { pb: 2 },
        }}
      >
        <Box>
          <FormLabel label={t("form.app")} required />
          <TextField
            select
            fullWidth
            size="small"
            value={app}
            onChange={(e) => onAppChange(e.target.value)}
            placeholder={t("form.appPlaceholder")}
          >
            {REPORT_APPS.map((appName) => (
              <MenuItem key={appName} value={appName}>
                {appName}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box>
          <FormLabel label={t("form.email")} required />
          <TextField
            fullWidth
            size="small"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder={t("form.emailPlaceholder")}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
        >
          <FormLabel label={t("form.description")} required />
          <TextField
            fullWidth
            multiline
            minRows={6}
            size="small"
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            placeholder={t("form.descriptionPlaceholder")}
            slotProps={{ htmlInput: { style: { resize: "none" } } }}
            sx={{
              flex: 1,
              alignSelf: "stretch",
              "& .MuiOutlinedInput-root": {
                height: "100%",
                alignItems: "stretch",
              },
              "& textarea": {
                height: "100% !important",
                overflow: "auto !important",
                boxSizing: "border-box",
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
